<!-- 欠费管理 -->
<template>
  <div class="container">
    <div class="flex-box">
      <div class="flex-box-left">
        <el-card>
           <div slot="header" class="clearfix">
                <span style="font-weight: bold;font-size: 16px;">楼宇结构</span>
            </div>
          <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText"
            style="margin-bottom: 20px;"
          >
          </el-input>

          <el-tree
            class="filter-tree"
            :data="data2"
            :props="defaultProps"
            default-expand-all
            :filter-node-method="filterNode"
            ref="tree2"
          >
          </el-tree>
        </el-card>
      </div>
      <div class="flex-box-right">
        <el-card>
            <div slot="header" class="clearfix">
                <span style="font-weight: bold;font-size: 16px;">业主信息</span>
            </div>
            <div style="margin-bottom:20px;">
                <el-button @click="handleDisable">停用</el-button>
                <el-button
                type="primary"
                @click="handleRecover"
                >恢复使用</el-button>
            </div>
          <el-table
            :data="dataList"
            border
            class="table"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
          >
          <el-table-column
            type="selection"
            width="55">
           </el-table-column>
            <el-table-column
              prop="number"
              label="编号"
              sortable
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="业主名称"
            >
            </el-table-column>
            <el-table-column
              prop="address"
              label="详细地址"
            >
            </el-table-column>
            <el-table-column
              prop="userState"
              label="用户状态"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="noDeductions"
              label="未扣款金额"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="account"
              label="账户余额"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="arrearageNum"
              label="欠费金额"
              width="100"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click="handleEdit(scope.$index, scope.row)"
                >停用表计</el-button>
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  class="red"
                  @click="handleDelete(scope.$index, scope.row)"
                >恢复表计</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>

      <el-dialog :title="dialogOptText" :visible.sync="dialogFormVisible">
        <el-table :data="gridData" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column property="state" label="表计状态" width="150"></el-table-column>
            <el-table-column property="num" label="编号" width="200"></el-table-column>
            <el-table-column property="status" label="使用状态"></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="dialogFormVisible = false">确定{{optText}}</el-button>
        </div>
        </el-dialog>
    </div>
  </div>

</template>

<script>
export default {
  name: "arrearagelist",
  data() {
    return {
      filterText: "",
      dialogFormVisible: false,     // 表计操作浮层
      optText: '停用',
      multipleSelection: [],  //  存储选中业主
    //   住宅结构
      data2: [
        {
          id: 1,
          label: "住宅结构管理",
          children: [
            {
              id: 4,
              label: "清华信息港",
              children: [
                {
                  id: 9,
                  label: "第一层"
                },
                {
                  id: 10,
                  label: "第二层"
                }
              ]
            }
          ]
        }
      ],
      defaultProps: [],
    //   业主列表
      dataList: [
        {
          number: 1,
          name: "深圳XX科技XXX",
          address: "清华信息港第三层-0319",
          userState: "已开户",
          noDeductions: '111.23',
          account: '0.00',
          arrearageNum: '-111.23',
        },
        {
          number: 2,
          name: "深圳XX网络XXX",
          address: "清华信息港第三层-0319",
          userState: "已开户",
          noDeductions: '111.23',
          account: '0.00',
          arrearageNum: '-111.23',
        }
      ],
    //   表计列表
      gridData: [{
          state: '离线',
          num: '60000712',
          status: '正常使用'
        },
        {
          state: '离线',
          num: '60000713',
          status: '正常使用'
        },
      ]
    };
  },
  computed: {
      dialogOptText() {
          return this.optText+"表计"
      }
  },
  watch: {
    filterText(val) {
      this.$refs.tree2.filter(val);
    }
  },

  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 业主选中
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    // handleEdit
    handleEdit(index, row) {
        this.optText = "停用";
        this.dialogFormVisible = true;
    },
    // 恢复表计
    handleDelete(index, row) {
        this.optText = "恢复";
        this.dialogFormVisible = true;
    },
    // 选择表计
    handleSelectionChange() {},
    // 批量停用
    handleDisable() {

    },
    // 批量恢复
    handleRecover() {

    }
  }
};
</script>
<style lang='less' scoped>
.flex-box {
  display: flex;
  width: 100%;
  display: -webkit-flex;
  flex-direction: row;
  .flex-box-left {
    width: 300px;
    margin-right: 20px;
  }
  .flex-box-right {
    flex: 1;
  }
}
</style>